import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Product, ProductDetails } from 'src/app/models';
import { ContentService } from 'src/app/services/content/content.service';
import { ProductQuery, ProductService } from 'src/app/services/product';
import { ProductCardComponent } from 'src/app/shared/components/product/card';

@Component({
  selector: 'app-suggested-products',
  templateUrl: './suggested-products.component.html',
  styleUrls: ['./suggested-products.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ProductCardComponent, AsyncPipe],
})
export class SuggestedProductsComponent implements OnInit {
  private contentService = inject(ContentService);
  private productService = inject(ProductService);
  private productQuery = inject(ProductQuery);

  @Input() product!: ProductDetails;

  suggestedProducts: Observable<Product[]>;
  title: string;

  constructor() {
    const sharedContent = this.contentService.getSharedContent();
    this.title = sharedContent.get('suggestedProductsTitle') || 'Andre kiggede på';
  }

  ngOnInit() {
    this.productService.getSuggestedProducts(5);
    this.suggestedProducts = this.productQuery.selectSuggestedProducts$.pipe(switchMap((ids) => this.productQuery.selectMany(ids)));
  }
}
